<div class="flex flex-col gap-2">
  <label class="text-sm font-semibold text-gray-700">
    <span i18n="@@product.section.images">Profile Image(s)</span>
    <span class="text-red-500">*</span>
  </label>

  <div class="flex items-center overflow-hidden rounded-lg border border-gray-200 bg-gray-50">
    <span class="text-placeholder flex-1 px-4 py-2.5 text-sm" i18n="@@product.placeholder.selectFiles">
      Select Files Or Images
    </span>
    <button
      type="button"
      (click)="fileInput.click()"
      class="cursor-pointer bg-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-300"
      i18n="@@product.button.upload">
      Upload
    </button>
    <input
      #fileInput
      type="file"
      multiple
      class="hidden"
      (change)="onFileSelect($event)"
      accept="image/jpeg,image/jpg,image/png,image/webp" />
  </div>

  @for (imgErr of errors(); track $index) {
    <p class="text-xs text-red-500">{{ imgErr }}</p>
  }
  @if (images().length === 0 && errors().length === 0) {
    <p class="text-placeholder text-xs" i18n="@@product.validation.imageRequired">
      At least one product image is required
    </p>
  }

  @if (images().length > 0) {
    <div class="mt-2 grid grid-cols-3 gap-3 md:grid-cols-6">
      @for (img of images(); track $index) {
        <div
          class="group relative h-24 overflow-hidden rounded-lg border-2 transition"
          [class.border-primary]="img.isPrimary"
          [class.border-gray-200]="!img.isPrimary">
          <img [src]="img.preview" class="h-full w-full object-cover" alt="" />
          <div
            class="absolute inset-0 flex items-center justify-center gap-1.5 bg-black/40 opacity-0 transition group-hover:opacity-100">
            <button type="button" (click)="setPrimary.emit($index)" class="text-primary rounded-md bg-white p-1.5">
              <i class="fa-solid fa-star text-[10px]"></i>
            </button>
            <button type="button" (click)="removeImg.emit($index)" class="rounded-md bg-white p-1.5 text-gray-600">
              <i class="fa-solid fa-trash text-[10px]"></i>
            </button>
          </div>
          @if (img.isPrimary) {
            <span
              class="bg-primary absolute top-1 left-1 rounded px-1.5 py-0.5 text-[9px] font-bold text-white"
              i18n="@@product.image.primary">
              Primary
            </span>
          }
        </div>
      }
    </div>
  }
</div>
